import {set} from 'vue';

import Routing from 'routing';
import request from '../utils/request';

const ADD       = 'ADD';
const DATA      = 'DATA';
const UPDATE    = 'UPDATE';
const REMOVE    = 'REMOVE';

const WIDGET_SHOW = 'WIDGET_SHOW';
const WIDGET_HIDE = 'WIDGET_HIDE';
const AVAILABLE_WARN = 'AVAILABLE_WARN';

const GET_RECOMMENDED_PRODUCT = 'GET_RECOMMENDED_PRODUCT';
const GET_RECOMMENDED_PRODUCT_LAYER = 'GET_RECOMMENDED_PRODUCT_LAYER';
const GET_SAMPLES = 'GET_SAMPLES';

const NOTIFICATION_HIDE = 'NOTIFICATION_HIDE';
const LOCK_GIFT_CHOICES = 'LOCK_GIFT_CHOICES';

const state = {
    widgetVisible: false,
    isNotification: false,
    isRefAvailable: true,
    lockGiftChoices: false,
    notAvailableMessage: '',
    recommendedProduct: [],
    recommendedProductLayer: [],
    samples: [],
    data: {
        items: [],
        itemsTotal: 0,
        itemsTotalDiscounted: 0,
        adjustmentsTotal: 0,
        total: 0,
        adjustments: [],
        promotion: null,
        promotionCode: null,
        giftsChoice: null,
        teaser: null,
        user: {
          home: {
            fidelityPoints: 0
          }
        },
        totalFidelityPoint: 0
    },
    cartIsLoaded: false,
};

const actions = {
    init(){
        this.dispatch('cart/getCart');
    },

    async getCart({commit}) {
        try {
            set(state, 'cartIsLoaded', false);
            const {data} = await request(Routing.generate('cart_api_get'));
            commit(DATA, data.data || {});
        } catch (err) {
            console.error(err);
        }

    },

    async checkStockAvailable({commit, dispatch}, {orderable, quantity}) {
        try {
            const {data} = await request.get(Routing.generate('site_commerce_cart_check_stock_available', {'reference': orderable.id}));
            commit(AVAILABLE_WARN, data || {});
            if (data.isAvailable) {
              dispatch('addToCart', {orderable, quantity});
            }
        } catch (err) {
            console.error(err);
        }
    },

    async addToCart({commit}, {orderable, quantity}) {

        try {
            const {data} = await request.post(Routing.generate('cart_api_add_items'), [{orderable, quantity}]);
            commit(ADD, data.data || {});

            if (typeof tc_events_20 === "function") {
              let lastProduct = data.data.items[data.data.items.length - 1];

              let tcEvent = {
                'basket_id': lastProduct.id,
                'quantity': lastProduct.quantity,
                'price_ati': lastProduct.unitPrice/100,
                'product_id': lastProduct.orderable.id,
                'product_EAN': lastProduct.orderable.eanCode,
                'product_brand': lastProduct.orderable.brand,
                'product_sub_family': lastProduct.orderable.data.mainCategory.title || '',
                // 'product_family': lastProduct.orderable.product.mainCategory.parent.title,
                'bundle': 0
              }

              tc_events_20(this,"add_to_cart",tcEvent);
            }
        } catch (err) {
            console.error(err);
        }
    },

    async updateCartItem({commit, dispatch}, {reference, quantity}) {
        if (isNaN(quantity) || !quantity) {
            setTimeout(() => {
                dispatch('getCart');
            }, 1000);
        } else {
            const payload = [{item: reference, quantity}];

            const {data} = await request.patch(Routing.generate('cart_api_update_items'), payload);
            commit(UPDATE, data.data || {});

            if (typeof tc_events_20 === "function") {

              var currentProduct = null;
              for (let i = 0; i < data.data.items.length; i++) {
                  if (data.data.items[i].id == reference) {
                      var currentProduct = data.data.items[i];
                  }
              }

              if (currentProduct) {
                  let tcEvent = {
                      'basket_id': currentProduct.id,
                      'quantity': currentProduct.quantity,
                      'price_ati': currentProduct.unitPrice/100,
                      'product_id': currentProduct.orderable.data.id,
                      'product_EAN': currentProduct.orderable.data.eanCode,
                      'product_brand': currentProduct.orderable.data.brand,
                      'product_sub_family': currentProduct.orderable.data.mainCategory.title,
                      //'product_family': currentProduct.orderable.data.mainCategory.parent.title,
                      'bundle': 0
                  }

                  tc_events_20(this,"edit_cart",tcEvent);
              }
            }
        }
    },

    async removeCartItem({commit}, payload) {
        const {data} = await request.delete(Routing.generate('cart_api_delete_item', payload));
        commit(REMOVE, data.data || {});
    },

    async getRecommendedProductForCartPage({commit}) {
        try {
            const {data} = await request(Routing.generate('site_commerce_recommended_product'));
            commit(GET_RECOMMENDED_PRODUCT, data || {});
        } catch (err) {
            console.error(err);
        }
    },

    async getRecommendedProductForCartLayer({commit}) {
        try {
            const {data} = await request(Routing.generate('site_commerce_recommended_product', {'isLayer' : true}));
            commit(GET_RECOMMENDED_PRODUCT_LAYER, data || {});
        } catch (err) {
            console.error(err);
        }
    },

    async getSamples({commit}) {
        try {
            const {data} = await request(Routing.generate('site_commerce_samples'));
            commit(GET_SAMPLES, data.samples || []);
        } catch (err) {
            console.error(err);
        }
    },

    toggleWidget: ({commit, state}, payload) => {
        if (payload.isNotification && state.widgetVisible) {
            commit(WIDGET_SHOW, payload.isNotification);
        } else {
            commit(state.widgetVisible ? WIDGET_HIDE : WIDGET_SHOW, payload.isNotification);
        }
    },

    showWidget: ({commit}, payload) => {
        commit(WIDGET_SHOW, payload.isNotification);
    },

    hideWidget: ({commit}) => {
        commit(WIDGET_HIDE);
    },
    hideNotification: ({commit}) => {
        commit(NOTIFICATION_HIDE);
    },

    setLockGiftChoices: ({commit}) => {
        commit(LOCK_GIFT_CHOICES);
    }
};

const getters = {
    items(state) {
        return state.data.items;
    },
    recommendedProduct(state) {
        return state.recommendedProduct;
    },
    recommendedProductForLayer(state) {
        return state.recommendedProductLayer;
    },
    itemsTotal(state) {
        const {itemsTotal} = state.data || {};
        return Number(itemsTotal) || 0;
    },
    itemsTotalDiscounted(state) {
        const {itemsTotalDiscounted} = state.data || {};
        return Number(itemsTotalDiscounted) || 0;
    },
    discountAmount(state) {
        const {discountAmount} = state.data || {};
        return Number(discountAmount) || 0;
    },
    adjustmentsTotal(state) {
      const {adjustmentsTotal} = state.data || {};
      return Number(adjustmentsTotal) || 0;
    },
    total(state) {
        const {total} = state.data || {};
        return Number(total) || 0;
    },
    totalFidelityPoint(state) {
        const {totalFidelityPoint} = state.data || {};
        return Number(totalFidelityPoint) || 0;
    },
    gain(state) {
        const {itemsTotal} = state.data || {};
        return Math.floor(Number(itemsTotal) / 500) || 0;
    },
    shippingFees(state) {
        const adjustments = state.data.adjustments;
        if (adjustments) {
            return adjustments.find(function (adj) { return adj.type === 'shippingFees' });
        }
    },
    giftsChoice(state) {
        const {giftsChoice} = state.data || {};
        return giftsChoice;
    },
    widgetVisible(state) {
        return state.widgetVisible;
    },
    isNotification(state) {
        return state.isNotification;
    },
    lockGiftChoices(state) {
        return state.lockGiftChoices;
    },
    promotionCode(state) {
        return state.data.promotionCode;
    },
    promotion(state) {
        return state.data.promotion;
    },
    teaser(state) {
        return state.data.teaser;
    },
    gift(state) {
        const {giftsChoice = [], items = []} = state.data || {};

        return items.find(item => giftsChoice.find(g => g.id == item.orderable.id ));
    },
    fidelityPointLeft(state) {

        if (state.data === undefined || state.data === null) {
            return 0;
        }

        if (state.data.user === undefined || state.data.user === null) {
            return 0;
        }

        if (state.data.user.home === undefined || state.data.user.home === null) {
          return 0;
        }

        return state.data.user.home.fidelityPoints - state.data.totalFidelityPoint;
    },
    notAvailableMessage(state) {
        return state.notAvailableMessage;
    },
    isRefAvailable(state) {
        return state.isRefAvailable;
    },
    sampleItems(state) {
        return state.data.items.filter(item => item.gift && item.gift.type === 'sample');
    },
    samples(state) {
        return state.samples;
    },
    countItems(state) {
        if (state.data.items) {
            return state.data.items.filter(item =>
                item.gift === null
                || item.gift.orderableRepository === 'site.repository.fidelity_gift'
            ).length;
        }

        return 0;
    },
    cartIsLoaded(state) {
        return state.cartIsLoaded;
    }
};

const mutations = {
    [DATA](state, data) {
        set(state, 'data', data);
        set(state, 'cartIsLoaded', true);
    },
    [ADD](state, cart) {
      set(state, 'data', cart);
      set(state, 'lockGiftChoices', false);
    },
    [UPDATE](state, cart) {
        set(state, 'data', cart);
    },
    [REMOVE](state, cart) {
        set(state, 'data', cart);
    },
    [WIDGET_SHOW](state, isNotification) {
        set(state, 'isNotification', isNotification);
        set(state, 'widgetVisible', true);
        this.dispatch('cart/getRecommendedProductForCartLayer');
    },
    [WIDGET_HIDE](state) {
        set(state, 'isNotification', false);
        set(state, 'widgetVisible', false);
    },
    [GET_RECOMMENDED_PRODUCT](state, recommendedProduct) {
        // window.ebRecoIds = window.ebRecoIds || [];
        // window.ebRecoIds.push(recommendedProduct.ebId);
      set(state, 'recommendedProduct', recommendedProduct.recommendedProducts);

    },
    [GET_RECOMMENDED_PRODUCT_LAYER](state, recommendedProduct) {
        // window.ebRecoIds = window.ebRecoIds || [];
        // window.ebRecoIds.push(recommendedProduct.ebId);
        set(state, 'recommendedProductLayer', recommendedProduct.recommendedProducts);
    },
    [NOTIFICATION_HIDE](state) {
        set(state, 'isNotification', false);
    },
    [AVAILABLE_WARN](state, data) {
        set(state, 'isRefAvailable', data.isAvailable);
        set(state, 'notAvailableMessage', data.message);
    },
    [GET_SAMPLES](state, samples) {
        set(state, 'samples', samples)
    },
    [LOCK_GIFT_CHOICES](state) {
      set(state, 'lockGiftChoices', true);
    }
};

const Store = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default Store;



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/store/modules/cart.js